import { UserPayload } from "../models/SiteModel";

const URLAPI = process.env.REACT_APP_BASE_URL;

export class NotificacionUnauthorizedError extends Error {
  constructor() {
    super("No autorizado para consultar notificaciones.");
    this.name = "NotificacionUnauthorizedError";
  }
}

export const NOTIFICACION_TIPOS = {
  PEDIDO_WEB: "PEDIDO_WEB",
  VENTA_WEB: "VENTA_WEB",
} as const;

export type NotificacionTipo = typeof NOTIFICACION_TIPOS[keyof typeof NOTIFICACION_TIPOS];

export type NotificacionDto = {
  idNotificacion: number;
  tipo: NotificacionTipo | string;
  destino: string;
  titulo: string;
  mensaje: string;
  idLocal: number;
  idReferencia?: number;
  referenciaTipo: string;
  data?: string;
  fecha: string;
  leida: boolean;
};

const normalizeNotificacion = (item: any): NotificacionDto => ({
  idNotificacion: item.idNotificacion ?? item.IdNotificacion ?? 0,
  tipo: item.tipo ?? item.Tipo ?? "",
  destino: item.destino ?? item.Destino ?? "",
  titulo: item.titulo ?? item.Titulo ?? "",
  mensaje: item.mensaje ?? item.Mensaje ?? "",
  idLocal: item.idLocal ?? item.IdLocal ?? 0,
  idReferencia: item.idReferencia ?? item.IdReferencia ?? undefined,
  referenciaTipo: item.referenciaTipo ?? item.ReferenciaTipo ?? "",
  data: item.data ?? item.Data ?? "",
  fecha: item.fecha ?? item.Fecha ?? "",
  leida: item.leida ?? item.Leida ?? false,
});

export async function fetchNotificacionesPendientes(user: UserPayload, idLocal = 0, limite = 20, signal?: AbortSignal) {
  const response = await fetch(`${URLAPI}/Notificacion/Pendientes?idLocal=${idLocal}&limite=${limite}`, {
    method: "GET",
    signal,
    headers: {
      Authorization: "Bearer " + user.token,
    },
  });

  if (response.status === 401 || response.status === 403) {
    throw new NotificacionUnauthorizedError();
  }

  if (!response.ok) {
    throw new Error("No se pudieron obtener las notificaciones.");
  }

  const data = await response.json();
  return Array.isArray(data) ? data.map(normalizeNotificacion) : [];
}

export async function fetchMarcarNotificacionLeida(user: UserPayload, idNotificacion: number) {
  const response = await fetch(`${URLAPI}/Notificacion/MarcarLeida/${idNotificacion}`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + user.token,
    },
  });

  if (response.status === 401 || response.status === 403) {
    throw new NotificacionUnauthorizedError();
  }

  if (!response.ok) {
    throw new Error("No se pudo marcar la notificacion como leida.");
  }
}
